const APP_LOCALE = process.env.VUE_APP_I18N_LOCALE
let dateSettings = {}
if (APP_LOCALE === 'tr') {
  dateSettings = {
    dateFormat: 'dd-MM-yyyy',
    datetimeFormat: 'dd-MM-yyyy HH:mm',
    firstDayOfWeek: 1,
    monthNames: [
      'Ocak',
      'Şubat',
      'Mart',
      'Nisan',
      'Mayıs',
      'Haziran',
      'Temmuz',
      'Ağustos',
      'Eylül',
      'Ekim',
      'Kasım',
      'Aralık'
    ],
    dayNames: ['Pzr', 'Pts', 'Sa', 'Çar', 'Per', 'Cu', 'Cts']
  }
} else if (APP_LOCALE === 'en') {
  dateSettings = {
    dateFormat: 'MM/dd/yyyy',
    datetimeFormat: 'MM/dd/yyyy HH:mm',
    firstDayOfWeek: 0,
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    dayNames: ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'S']
  }
}

export default { ...dateSettings }
